import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const FeatureCard = (props) => {
  const Icon = props.icon;
  const title = props.title;
  const description = props.description;
  const link = props.link;
  const linkText = props.linkText || "Learn more";
  const variant = props.variant || "default";
  const className = props.className || "";

  const baseClasses = {
    default: "card-feature group",
    highlight: "card-highlight",
    minimal: "p-6 rounded-xl hover:bg-slate-50 group"
  };

  const iconClasses = {
    default: "icon-container feature-icon-hover",
    highlight: "w-14 h-14 rounded-xl bg-white/20 flex items-center justify-center text-white",
    minimal: "w-12 h-12 rounded-lg bg-[#F0FDF4] flex items-center justify-center text-[#1F7A3A]"
  };

  const titleClasses = {
    default: "text-xl font-bold text-slate-900 mb-3",
    highlight: "text-xl font-bold text-white mb-3",
    minimal: "text-lg font-semibold text-slate-900 mb-2"
  };

  const descClasses = {
    default: "text-slate-600 leading-relaxed",
    highlight: "text-green-100 leading-relaxed",
    minimal: "text-slate-600 text-sm leading-relaxed"
  };

  const Content = (
    <>
      <div className={iconClasses[variant]}>
        {Icon && <Icon className="w-6 h-6" />}
      </div>
      <h3 className={titleClasses[variant]}>{title}</h3>
      <p className={descClasses[variant]}>{description}</p>
      {link && (
        <div className={`mt-4 flex items-center gap-2 text-sm font-medium ${
          variant === 'highlight' ? 'text-[#C8A24A]' : 'text-[#1F7A3A]'
        }`}>
          {linkText}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1" style={{ transition: 'transform 0.2s' }} />
        </div>
      )}
    </>
  );

  if (link) {
    return (
      <Link 
        to={link} 
        className={`${baseClasses[variant]} block ${className}`}
        data-testid={`feature-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
      >
        {Content}
      </Link>
    );
  }

  return (
    <div 
      className={`${baseClasses[variant]} ${className}`}
      data-testid={`feature-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {Content}
    </div>
  );
};
